export const hasSearchString = (
  target: string,
  searchString: string
): boolean =>
  target.toLocaleUpperCase().includes(searchString.toLocaleUpperCase());
